import React from "react";
import { Card } from "react-bootstrap";


function CardsInfo() {
    return (
      <section className="section bg-c-light border-top">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4 text-center">
              <h3 className="main-heading">شرکت فنی مهندسی پویارایانه فرتاک</h3>
              <div className="underline mx-auto"></div>
            </div>
  
            <div className="col-md-4 text-center">
              <Card className="card shadow"style={{ height: '100%' }}>
                <Card.Body>
                  {/* <Card.Title >چشم انداز شرکت</Card.Title> */}
                  <h5 className="mt-2">چشم انداز شرکت</h5>
                  <Card.Text className="description smal">
                    شرکت ما با هدف ایجاد راه‌حل‌های نوآورانه و کارآمد در عرصه طراحی نرم‌افزار، به دنبال تبدیل ایده‌ها به واقعیت است. ما بر این باوریم که فناوری می‌تواند زندگی‌ها را بهبود بخشد و به همین دلیل، متعهد به ارائه محصولات و خدمات با کیفیت بالا هستیم. چشم‌انداز ما، تبدیل شدن به یکی از پیشگامان صنعت نرم‌افزار در منطقه، با تمرکز بر رضایت مشتری و پیشرفت مستمر است.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
  
            <div className="col-md-4 text-center">
              <Card className="card shadow"style={{ height: '100%' }}>
                <Card.Body>
                  {/* <Card.Title>ماموریت ما</Card.Title> */}
                  <h5 className="mt-2">ماموریت ما</h5>
                  <Card.Text className="description smal">
                    ماموریت ما ارائه راه‌حل‌های نرم‌افزاری خلاقانه و سفارشی است که به کسب‌وکارها کمک کند تا اهداف خود را به بهترین نحو ممکن محقق کنند. ما با بهره‌گیری از فناوری‌های پیشرفته و تیمی متشکل از متخصصان باتجربه، به دنبال ایجاد نرم‌افزارهایی هستیم که کارایی، انعطاف‌پذیری و رضایت مشتری را تضمین کند. هدف ما، ارتقاء تجربه کاربری و بهینه‌سازی فرآیندها برای مشتریان‌مان است.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
  
            <div className="col-md-4 text-center">
              <Card className="card shadow"style={{ height: '100%' }}>
                <Card.Body>
                  {/* <Card.Title></Card.Title> */}
                  <h5 className="mt-2">ارزش های اصلی ما</h5>
                  <Card.Text className="description smal">
                    ارزش‌های اصلی ما محور فعالیت‌ها و تصمیم‌گیری‌های ما هستند. ما به دنبال نوآوری در ارائه راه‌حل‌های خلاقانه و به‌روز هستیم که نیازهای مشتریان را به بهترین شکل برآورده کند. کیفیت بالای محصولات و خدمات‌مان را در اولویت قرار داده و به بهبود مداوم فرآیندهایمان می‌پردازیم. همچنین، همکاری مؤثر درون تیم و با مشتریان را به عنوان کلید موفقیت می‌دانیم و به مسئولیت‌پذیری در ارائه نتایج کار خود متعهد هستیم.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </section>
    );
  }
  
  export default CardsInfo;